import React from 'react';

export default function Contact() {
  return (
    <section id="contact" className="py-24 px-6 max-w-5xl mx-auto">
      <div className="max-w-xl">
        <p className="text-accent font-body text-sm tracking-[0.2em] uppercase mb-4">Contact</p>
        <h2 className="font-display text-4xl text-ink mb-6">Let's talk.</h2>
        <p className="font-body text-muted leading-relaxed mb-10">
          Open to freelance projects, collaborations.
        </p>

        <div className="space-y-4">
          <a
            href="mailto:baki.sevgul@gmail.com"
            className="flex items-center gap-4 group"
          >
            <span className="w-8 h-px bg-accent group-hover:w-12 transition-all duration-300" />
            <span className="font-body text-sm text-muted group-hover:text-ink transition-colors">
              baki.sevgul@gmail.com
            </span>
          </a>
          <a
            href="https://github.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-4 group"
          >
            <span className="w-8 h-px bg-accent group-hover:w-12 transition-all duration-300" />
            <span className="font-body text-sm text-muted group-hover:text-ink transition-colors">
              GitHub
            </span>
          </a>
          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-4 group"
          >
            <span className="w-8 h-px bg-accent group-hover:w-12 transition-all duration-300" />
            <span className="font-body text-sm text-muted group-hover:text-ink transition-colors">
              LinkedIn
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
